import axios from "axios";
import { Base_URL } from "../url";

// Fetch all resources for dropdown
export const fetchAllResources = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/ResourceMasters`,
    );
    return response.data.map((resource) => ({
      value: resource.resourceId,
      label: `${resource.resourceId} - ${resource.name}`,
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching resources!";
  }
};

// Generate time card report with multi-resource support
export const generateTimeCardReport = async (reportData) => {
  try {
    console.log("Report data to be sent:", reportData);

    // Get organisationId from localStorage
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const organisationId =
      userDetails?.organisationId || localStorage.getItem("orgId");

    // Prepare request body
    const requestBody = {
      resourceIds:
        reportData.ResourceCodes && reportData.ResourceCodes.length > 0
          ? reportData.ResourceCodes
          : null,
      projectCode: reportData.ProjectCode || null,
      taskId: reportData.TaskId || null,
      fromDate: reportData.FromDate || null,
      toDate: reportData.ToDate || null,
      organisationId: organisationId ? parseInt(organisationId) : null,
    };

    console.log("Request body being sent:", requestBody);

    const response = await axios.post(
      `${Base_URL}/DailyTimecard/GetTimecardsReport`,
      requestBody,
    );

    console.log("API Response:", response.data);

    // Transform the API response with correct field names
    const transformedData = response.data.data.map((item) => ({
      DTId: item.dtId,
      ResourceId: item.resourceId,
      ResourceCode: item.resourceId,
      UserName: item.userName,
      Date: item.date ? new Date(item.date).toISOString().split("T")[0] : "",
      ProjectCode: item.projectCode,
      ProjectName: item.projectName || "N/A",
      TaskId: item.taskId,
      TaskName: item.taskName || "N/A",
      Hours: item.hours,
      Remarks: item.remarks,
      Location: item.location,
      Status: item.status,
      StatusName: item.statusName,
      Cost: item.cost,
      BillableAmount: item.billableAmount,
      OrganisationId: item.organisationId,
      ProjectDisplay: item.projectDisplay,
      TaskDisplay: item.taskDisplay,
    }));

    return {
      message: response.data.message,
      count: response.data.count,
      resourceIds: response.data.resourceIds,
      projectCode: response.data.projectCode,
      taskId: response.data.taskId,
      fromDate: response.data.fromDate,
      toDate: response.data.toDate,
      organisationId: response.data.organisationId,
      data: transformedData,
    };
  } catch (error) {
    console.error("API Error:", error);
    if (error.response?.data) {
      throw error.response.data;
    }
    throw { message: "Error generating time card report!" };
  }
};

// NEW: Update/Edit Timecard
// Update this function in your TimeCardReport.js API file
export const updateTimecard = async (dtid, updateData) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const currentUser = userDetails?.userId || localStorage.getItem("memberId");

    // Map frontend field names to backend field names
    const requestBody = {
      userName: updateData.userName, // This won't be changed as it's read-only
      date: updateData.date,
      projectCode: updateData.projectCode,
      hours: updateData.hours,
      tasks: updateData.tasks,
      remarks: updateData.remarks,
      location: updateData.location,
      resourceId: updateData.resourceId,
      organisationId: updateData.organisationId,
      status: updateData.status,
      modifiedBy: currentUser,
    };

    // Remove undefined fields
    Object.keys(requestBody).forEach((key) => {
      if (requestBody[key] === undefined || requestBody[key] === null) {
        delete requestBody[key];
      }
    });

    const response = await axios.put(
      `${Base_URL}/DailyTimecard/UpdateDailyTimecard/${dtid}`,
      requestBody,
    );

    return response.data;
  } catch (error) {
    console.error("Error updating timecard:", error);
    if (error.response?.data) {
      throw error.response.data;
    }
    throw { message: "Error updating timecard!" };
  }
};

// NEW: Soft Delete Timecard
export const deleteTimecard = async (dtid) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const currentUser = userDetails?.userId || localStorage.getItem("memberId");

    const response = await axios.delete(
      `${Base_URL}/DailyTimecard/DeleteDailyTimecard/${dtid}`,
      {
        params: { deletedBy: currentUser },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting timecard:", error);
    if (error.response?.data) {
      throw error.response.data;
    }
    throw { message: "Error deleting timecard!" };
  }
};

// NEW: Restore Soft Deleted Timecard
export const restoreTimecard = async (dtid) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const currentUser = userDetails?.userId || localStorage.getItem("memberId");

    const response = await axios.put(
      `${Base_URL}/DailyTimecard/RestoreDailyTimecard/${dtid}`,
      null,
      {
        params: { restoredBy: currentUser },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error restoring timecard:", error);
    if (error.response?.data) {
      throw error.response.data;
    }
    throw { message: "Error restoring timecard!" };
  }
};

// NEW: Get Deleted Timecards
export const getDeletedTimecards = async (organisationId = null) => {
  try {
    const params = organisationId ? { organisationId } : {};
    const response = await axios.get(
      `${Base_URL}/DailyTimecard/GetDeletedTimecards`,
      { params },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching deleted timecards:", error);
    if (error.response?.data) {
      throw error.response.data;
    }
    throw { message: "Error fetching deleted timecards!" };
  }
};

// import axios from "axios";
// import { Base_URL } from "../url";

// // Fetch all resources for dropdown
// export const fetchAllResources = async () => {
//   try {
//     const response = await axios.get(
//       `${Base_URL}/SalaryProcess/ResourceMasters`,
//     );
//     return response.data.map((resource) => ({
//       value: resource.resourceId,
//       label: `${resource.resourceId} - ${resource.name}`,
//     }));
//   } catch (error) {
//     throw error.response?.data || "Error fetching resources!";
//   }
// };

// // Generate time card report with multi-resource support
// export const generateTimeCardReport = async (reportData) => {
//   try {
//     console.log("Report data to be sent:", reportData);

//     // Get organisationId from localStorage
//     const userDetails = JSON.parse(localStorage.getItem("userDetails"));
//     const organisationId =
//       userDetails?.organisationId || localStorage.getItem("orgId");

//     // Prepare request body
//     const requestBody = {
//       resourceIds:
//         reportData.ResourceCodes && reportData.ResourceCodes.length > 0
//           ? reportData.ResourceCodes
//           : null,
//       projectCode: reportData.ProjectCode || null,
//       taskId: reportData.TaskId || null,
//       fromDate: reportData.FromDate || null,
//       toDate: reportData.ToDate || null,
//       organisationId: organisationId ? parseInt(organisationId) : null,
//     };

//     console.log("Request body being sent:", requestBody);

//     const response = await axios.post(
//       `${Base_URL}/DailyTimecard/GetTimecardsReport`,
//       requestBody,
//     );

//     console.log("API Response:", response.data); // Add this for debugging

//     // FIXED: Transform the API response with correct field names
//     const transformedData = response.data.data.map((item) => ({
//       DTId: item.dtId, // FIXED: Changed from dtid to dtId
//       ResourceId: item.resourceId, // Add this
//       ResourceCode: item.resourceId, // Map resourceId to ResourceCode for compatibility
//       UserName: item.userName,
//       Date: item.date ? new Date(item.date).toISOString().split("T")[0] : "",
//       ProjectCode: item.projectCode,
//       ProjectName: item.projectName || "N/A", // ADD THIS - was missing
//       TaskId: item.taskId,
//       TaskName: item.taskName || "N/A", // ADD THIS - was missing
//       Hours: item.hours,
//       Remarks: item.remarks,
//       Location: item.location,
//       Status: item.status,
//       StatusName: item.statusName, // ADD THIS for better status display
//       Cost: item.cost,
//       BillableAmount: item.billableAmount,
//       OrganisationId: item.organisationId,
//       ProjectDisplay: item.projectDisplay,
//       TaskDisplay: item.taskDisplay,
//     }));

//     return {
//       message: response.data.message,
//       count: response.data.count,
//       resourceIds: response.data.resourceIds,
//       projectCode: response.data.projectCode,
//       taskId: response.data.taskId,
//       fromDate: response.data.fromDate,
//       toDate: response.data.toDate,
//       organisationId: response.data.organisationId,
//       data: transformedData,
//     };
//   } catch (error) {
//     console.error("API Error:", error);
//     if (error.response?.data) {
//       throw error.response.data;
//     }
//     throw { message: "Error generating time card report!" };
//   }
// };
